'use strict';

angular.module('atex.dam').directive('uiLinkToPage', ['$window','$injector', '$q', 'ContentService','$modal', 'UIConfigurationService', 'DamAclPermissionService', '$translate', 'DamNotificationService', 'DamActivityService', '$rootScope',
  function ($window, $injector, $q, ContentService, $modal, UIConfigurationService, DamAclPermissionService, $translate, DamNotificationService, DamActivityService, $rootScope) {
    return {
      restrict: 'ACE',
      templateUrl: 'views/ui-configuration/directive/link-to-page.html',
      scope: {
        field: "=",
        queryModel: "=",
        entry: "="
      },

      controller: function ($scope) {
        $scope.loadModal = function() {
          if ( $scope.field.config.shapeMode === 7 ) {
            $scope.loadShapeTemplateModal( "atex.dam.standard.Page.production.dam.create", "", "p.OnePage" );
          } else if ( $scope.field.config.shapeMode === 8 ) {
            $scope.loadShapeTemplateModal( "atex.dam.standard.Page.production.dam.build.book", "Build Fullbook", "p.OnePage" );
          } else {
            $scope.loadLinkToPageModal();
          }
        };
        $scope.loadShapeTemplateModal = function ( id, label, inputTemplate ) {
          var templateScope = $rootScope.$new(true);
          templateScope.type = id;
          templateScope.label = label;
          templateScope.inputTemplate = inputTemplate;

          //if(storyContentId) {
          //  templateScope.storyContentId = storyContentId;
          //}

          templateScope.article = atex.Content();

          templateScope.article.local.data = $scope.entry._data;
          templateScope.article.local.field = $scope.field;

          templateScope.canBeCancelled = true;

          var modal = $modal({
            show : true,
            scope : templateScope,
            template : 'views/dam-link-to-print-modal.html',
            modalClass : 'dam-modal-edit confirm-modal ng-cloak',
            backdrop : 'static',
            keyboard : false
          });

          templateScope.verified = (templateScope.confirm !== true);
          var deferred = $q.defer();

          var destroyModal = function() {
            modal.then(function(modalEl) {
              modalEl.on('hidden.bs.modal', function() {
                templateScope.$destroy();
                angular.element(this).remove();
              });
              modalEl.modal('hide');
            });
          };

          templateScope.doCancel = function() {
            destroyModal();
            deferred.resolve(false);
            $rootScope.$broadcast("dam:cancelItem");
          };

          templateScope.closeModal = function() {
            destroyModal();
            deferred.resolve(false);
          };

          templateScope.doSave = function() {
            destroyModal();
            deferred.resolve(false);
          };

          return deferred.promise;
        };
        $scope.loadLinkToPageModal = function () {
          var modalScope = $scope.$new(false);
          modalScope.model = {};

          if ( $scope.field.config.create ) {
            modalScope.header = $translate.getTranslationTable().__CREATE_PAGE__;
          } else {
            modalScope.header = $translate.getTranslationTable().__LINK_TO_PAGE__;
          }

          modalScope.pagePlaceholder = $translate.getTranslationTable().__PAGE_NUMBER__;
          modalScope.pagePositionPlaceholder = $translate.getTranslationTable().__POSITION__;
          modalScope.pagePubDate = $translate.getTranslationTable()._PUBLICATION_DATE_;
          modalScope.nestedSearchId = "search-query-form";
          modalScope.candidateStructure = {
            "contentId": "",
            "profile": "",
            "page": "",
            "publication": "",
            "edition": "",
            "zone": "",
            "section": "",
            "pubdate": "",
            "position": ""
          };
          modalScope.queryModel = {
            set: {}
          };

          modalScope.field = $scope.field;

          modalScope.getDate = function () {
            var date;

            if ( !_.isEmpty( modalScope.publEvent.pubdate ) ) {
              date = [{ id: new Date(parseInt(modalScope.publEvent.pubdate)) }];
            } else {
              var lastUsedDate = JSON.parse($window.localStorage.getItem("lastUsedDate"));
              if (lastUsedDate === null || lastUsedDate === "null") {
                date = [{ id: new Date() }];
              } else {
                date = [{ id: new Date(lastUsedDate) }];
              }
            }

            return date;
          };

          modalScope.getPublEvent = function () {
            var publEvent = atex.onecms.ObjectUtils.getByPath($scope.entry, "_data/aspects/atex.dam.standard.Publevents/data/publevents/0");

            if (!publEvent) {
              publEvent = {};
            }
            return publEvent;
          };

          modalScope.getPage = function () {
            var page = modalScope.publEvent.pending ? modalScope.publEvent.pendingPage : modalScope.publEvent.page;

            if ( _.isEmpty(page) ) {
              page = modalScope.publEvent.page;
            }

            return page;
          };

          modalScope.getPosition = function () {
            return _.isEmpty( modalScope.publEvent.position ) ? "" : modalScope.publEvent.position ;
          };

          modalScope.changePinPage = function() {
            //modalScope.pinPage = modalScope.pinPage;
          };

          modalScope.updateQuery = function( query ) {
            var queryModel = _.extend({}, query);

            if ( !_.isEmpty( modalScope.publEvent.profile ) && queryModel.profile_atex_desk_ss ) {
              queryModel.profile_atex_desk_ss.id = modalScope.publEvent.profile;
              queryModel.profile_atex_desk_ss.text = modalScope.publEvent.profile;
              queryModel.profile_atex_desk_ss.label = modalScope.publEvent.profile;
            }

            if ( !_.isEmpty( modalScope.publEvent.publication ) && queryModel.publication_atex_desk_ss ) {
              queryModel.publication_atex_desk_ss.id = modalScope.publEvent.publication;
              queryModel.publication_atex_desk_ss.text = modalScope.publEvent.publication;
              queryModel.publication_atex_desk_ss.label = modalScope.publEvent.publication;
            }

            if ( !_.isEmpty( modalScope.publEvent.edition ) && queryModel.edition_atex_desk_ss ) {
              queryModel.edition_atex_desk_ss.id = modalScope.publEvent.edition;
              queryModel.edition_atex_desk_ss.text = modalScope.publEvent.edition;
              queryModel.edition_atex_desk_ss.label = modalScope.publEvent.edition;
            }

            if ( !_.isEmpty( modalScope.publEvent.zone ) && queryModel.zone_atex_desk_ss ) {
              queryModel.zone_atex_desk_ss.id = modalScope.publEvent.zone;
              queryModel.zone_atex_desk_ss.text = modalScope.publEvent.zone;
              queryModel.zone_atex_desk_ss.label = modalScope.publEvent.zone;
            }

            if ( !_.isEmpty( modalScope.publEvent.section ) && queryModel.section_atex_desk_ss ) {
              queryModel.section_atex_desk_ss.id = modalScope.publEvent.section;
              queryModel.section_atex_desk_ss.text = modalScope.publEvent.section;
              queryModel.section_atex_desk_ss.label = modalScope.publEvent.section;
            }

            return queryModel;
          };

          modalScope.publEvent = modalScope.getPublEvent();

          modalScope.model.dates = modalScope.getDate();
          modalScope.modelDates = modalScope.getDate();

          modalScope.model.pagePosition = modalScope.getPosition();
          modalScope.model.pageNumber = modalScope.getPage();

          modalScope.pinPage = $window.localStorage.getItem("pinPagePreview") || false;

          modalScope.searchForm = 'js/dam/widgets/dam-search-form/dam-link-to-page-search.html';

          var modal = $modal({
            show: true,
            scope: modalScope,
            template: 'views/ui-configuration/widget/modal/link-to-page-widget-modal.html',
            modalClass: 'confirm-modal ng-cloak',
            backdrop: 'static',
            keyboard: false
          });

          modalScope.verified = (modalScope.confirm !== true);

          var parsedLastQuery = JSON.parse($window.localStorage.getItem("lastUsedQuery"));

          parsedLastQuery = modalScope.updateQuery( parsedLastQuery );

          modalScope.queryModel.set = {};
          modalScope.queryModel.set = angular.extend(modalScope.queryModel.set, parsedLastQuery);

          modalScope.resetPage = function (clearFolder, fromUI) {
            var convertedDate = new Date().valueOf();
            $window.localStorage.setItem("lastUsedDate", convertedDate);
            modalScope.model.dates = [{id: convertedDate}];
            modalScope.modelDates = [{id: convertedDate}];
            modalScope.searchScope = $("#" + modalScope.nestedSearchId).scope();
            var queryScope = modalScope.searchScope.$parent;
            queryScope.resetQuery(clearFolder, fromUI);
            for (var field in modalScope.model) {
              if (modalScope.model.hasOwnProperty(field)) {
                delete modalScope.model[field];
              }
            }
          };

          var destroyModal = function () {
            modal.then(function (modalEl) {
              modalEl.on('hidden.bs.modal', function () {
                modalScope.$destroy();
                modalEl.remove();
              });

              modalEl.modal('hide');
            });
          };

          $rootScope.$on("dam:dp.change", function(event, dates) {
            modalScope.model.dates = dates;
          });

          $rootScope.$on("dam:clearSearchUIFields", function() {
            modalScope.modelDates = [{ id: new Date() }];
            modalScope.model.dates = [{ id: new Date() }];
            modalScope.model.pagePosition = "";
            modalScope.model.pageNumber = "";
          });

          modalScope.doClose = function () {
            destroyModal();
          };

          modalScope.doSave = function () {
            var queryModel = modalScope.$$childHead.queryModel.set;
            if(!queryModel.profile_atex_desk_ss && $scope.field.config.profile) {
              $scope.missingFieldError("profile");
              return false;
            }

            if(!queryModel.publication_atex_desk_ss && $scope.field.config.publication) {
              $scope.missingFieldError("publication");
              return false;
            }

            if(!queryModel.edition_atex_desk_ss && $scope.field.config.edition) {
              $scope.missingFieldError("edition");
              return false;
            }

            if(!queryModel.zone_atex_desk_ss && $scope.field.config.zone) {
              $scope.missingFieldError("zone");
              return false;
            }

            if(!queryModel.section_atex_desk_ss && $scope.field.config.section) {
              $scope.missingFieldError("section");
              return false;
            }

            if(!modalScope.model.pageNumber && $scope.field.config.pageNumber) {
              $scope.missingFieldError("page number");
              return false;
            }

            //if(!modalScope.model.pagePosition && $scope.field.config.pagePosition) {
            //  $scope.missingFieldError("page position");
            //  return false;
            //}

            modalScope.candidateStructure.profile = (queryModel.profile_atex_desk_ss) ? queryModel.profile_atex_desk_ss.id : "";
            modalScope.candidateStructure.publication = (queryModel.publication_atex_desk_ss) ? queryModel.publication_atex_desk_ss.id : "";
            modalScope.candidateStructure.edition = (queryModel.edition_atex_desk_ss) ? queryModel.edition_atex_desk_ss.id : "";
            modalScope.candidateStructure.zone = (queryModel.zone_atex_desk_ss) ? queryModel.zone_atex_desk_ss.id : "";
            modalScope.candidateStructure.section = (queryModel.section_atex_desk_ss) ? queryModel.section_atex_desk_ss.id : "";
            modalScope.candidateStructure.page = modalScope.model.pageNumber || "";
            modalScope.candidateStructure.position = modalScope.model.pagePosition || "";
            modalScope.candidateStructure.contentId = $scope.entry ? $scope.entry.id : "New";

            if (modalScope.model.dates) {
              var date_chosen;

              if (Array.isArray(modalScope.model.dates)) {
                date_chosen = modalScope.model.dates[0];
              } else {
                date_chosen = modalScope.model.dates;
              }
              var convertedDate = new Date(date_chosen.id).valueOf();
              modalScope.candidateStructure.pubdate = convertedDate.toString();
              $window.localStorage.setItem("lastUsedDate", convertedDate);
            } else {
              $scope.missingFieldError("publication date");
              return false;
            }
            $window.localStorage.setItem("lastUsedQuery", JSON.stringify(queryModel));
            $window.localStorage.setItem("pinPagePreview", modalScope.pinPage );

            if ( modalScope.field.config && modalScope.field.config.create ) {
              $scope.createPage(modalScope.candidateStructure, modalScope);
            } else {
              $scope.addCandidate(modalScope.candidateStructure, modalScope);
            }
          };
        };

        $scope.missingFieldError = function (property) {
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (Missing required field:" + property + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        };

        $scope.addCandidate = function (candidateStructure, modalScope) {
          var PrintService;
          if (!PrintService) {
            PrintService = $injector.get("PrintService");
          }
          PrintService.addCandidate( candidateStructure ).then(function(data) {
            if ( data.data.status.lStatusCode === 200 ) {
              DamNotificationService.addNotification(atex.dam.Notification({
                type: 'success',
                message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
              }), false);
              modalScope.doClose();
              $rootScope.$broadcast('dam:updatedItem', $scope.entry);
            } else {
              var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + data.data.status.strErrorText + ")";
              DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
            }
          }).then(null, function(error) {
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.statusText + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        };

        $scope.createPage = function (candidateStructure, modalScope) {
          var PrintService;
          var message = $translate.getTranslationTable().__OPERATION_IN_PROGRESS__;

          if (!PrintService) {
            PrintService = $injector.get("PrintService");
          }

          DamNotificationService.addNotification(atex.dam.Notification({type: 'info', message: message}), false);

          PrintService.createPage( candidateStructure ).then(function(data) {
            if ( data.status === 200 ) {
              if ( data.data && data.data.contentId ) {
                DamNotificationService.addNotification(atex.dam.Notification({
                  type: 'success',
                  message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
                }), false);

                modalScope.doClose();

                if (modalScope.pinPage) {
                   $rootScope.$broadcast("dam:setAnchoredPreview", "previewView", true, data.data.contentId);
                }
              } else {
                var errMsg = ( data.data.status && data.data.status.strErrorText ) ? ( data.data.status.strErrorText ) : data.statusText;

                message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + errMsg + ")";
                DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
              }
            } else {
              message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + data.statusText + ")";
              DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
            }
          }).then(null, function(error) {
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.statusText + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        };
      },

      link: function (scope, element) {
        scope.$on('$destroy', function () {
          scope.$destroy();
          element.remove();
        });

        var pubInfo = atex.onecms.ObjectUtils.getByPath(scope.entry, "_data/aspects/atex.dam.standard.Publevents/data/publevents/0");

        if(pubInfo && (pubInfo.publication !== "")){
          scope.isLinked = true;
        } else {
          scope.isLinked = false;
        }

        if ( scope.field && scope.field.config && _.isArray(scope.field.config.types) ) {
          var objectType = atex.onecms.ObjectUtils.getByPath(scope.entry,"_data/aspects/contentData/data/objectType");
          scope.isVisible = _.find(scope.field.config.types, function(type) {
            return objectType === type;
          });
        } else {
          scope.isVisible = true;
        }

        scope.isPlaced = function () {
          var pubInfo = atex.onecms.ObjectUtils.getByPath(scope.entry, "_data/aspects/atex.dam.standard.Publevents/data/publevents/0");
          var objectType = atex.onecms.ObjectUtils.getByPath(scope.entry,"_data/aspects/contentData/data/objectType");
          var noUsePrint = atex.onecms.ObjectUtils.getByPath(scope.entry,"_data/aspects/contentData/data/noUsePrint");

          if (objectType === "image" && noUsePrint) {
            return true;
          }

          if(pubInfo){
            if((pubInfo.page) && (objectType !== "page") && (pubInfo.pending !== true)){
              return true;
            } else{
              return false;
            }
          } else {
            return false;
          }
        };
      }
    };
  }]);
